import React from 'react'
import { FormattedMessage } from 'react-intl'

export const YesNoString = ({ value }) => (value ? <FormattedMessage id="common.yes"/> :
  <FormattedMessage id="common.no"/>)
